// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "7a353127be3f2d5d","191": "a77b1cfa2a56c38a","396": "2026507f0eb5ec81","460": "5dbdfea45948b21b","498": "e1812af24bc0e9ea","917": "ae823f9c8f853197","985": "237b5f79f37ed03d",}[chunkId] + ".chunk.js"
}